module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"attendee":"Teilnehmer","cancel":"Abbrechen","save":"Speichern","theAttendeeHasCancelledOn":"Der Teilnehmer hat am {date} abgesagt."},"en":{"attendee":"Attendee","cancel":"Cancel","save":"Save","theAttendeeHasCancelledOn":"The attendee has cancelled on {date}."}}')
  delete Component.options._Ctor
}
